// extracted by mini-css-extract-plugin
export default {"container":"cP-z","topReviewHeading":"dP-z","criticalReview":"eP-z","favorableReview":"fP-z","vsSeparator":"gP-z"};